import React, { useContext, useEffect, useState } from "react";

import AuthContext from "../../store/auth-context";
import { userService } from "../../services/UserService";
import {
  MenuItem,
  Paper,
  Snackbar,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

function SearchUser(props: any) {
  const authCtx = useContext(AuthContext);
  const [t] = useTranslation();

  const [userName, setUserName] = useState<string>("");
  const [mobileNo, setMobileNo] = useState<string>("");
  const [dateOfBirth, setDateOfBirth] = useState<string>("");
  const [rollName, setRollName] = useState<any>("");
  const [roleId, setRoleId] = useState<number>(0);
  const [roleList, setRoleList] = useState<any>([]);
  const [roleError, setRoleError] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [modalType, setModalType] = useState<string>("error");
  const [loginAttemptconfirmationModel, setLoginAttemptConfirmationModel] =
    useState<boolean>(false);
  const [failedAttemptconfirmationModel, setFailedAttemptConfirmationModel] =
    useState<boolean>(false);

  const lang = localStorage.getItem("lang") ?? "en";

  const handleClose = () => setShowModal(false);

  useEffect(() => {
    if (props.isEditted) {
      setUserName(
        props.userDetails.firstName + " " + props.userDetails.lastName
      );
      setMobileNo(
        props.userDetails.callingCode + "-" + props.userDetails.mobile
      );
      setRollName(props.userDetails.roleName);
      setRoleId(props.userDetails.roleId);
    } else {
      const dob = props.userDetails.dateOfBirth
        ? new Date(props.userDetails.dateOfBirth).toLocaleDateString("en-GB")
        : "";
      setUserName(props.userDetails.fullName);
      setMobileNo(
        props.userDetails.callingCode + "-" + props.userDetails.mobile
      );
      setDateOfBirth(dob);
      setRollName(props.userDetails.roleName);
      setRoleId(props.userDetails.roleId === 0 ? 1 : props.userDetails.roleId);
    }
    setRoleList(props.userRoleList);
  }, []);

  const handleLoginComfirmationClose = () =>
    setLoginAttemptConfirmationModel(false);
  const handleFailedComfirmationClose = () =>
    setFailedAttemptConfirmationModel(false);

  const UpdateUserRole = async () => {
    authCtx.toggleLoader(true);
    const res = await userService.updateUserRole(props.userDetails.id, roleId);
    if (
      res &&
      res.data &&
      res.message &&
      res.message.status &&
      res.message.status === "Success"
    ) {
      props.setSkip(0);
      props.setIsReload(!props.isReload);
      props.handleAddClose();
    } else {
      setShowModal(true);
      setModalType("error");
      setModalText(t("Error"));
    }
    authCtx.toggleLoader(false);
  };

  const handleLoginAttemptSubmit = async () => {
    authCtx.toggleLoader(true);
    const res = await userService.resetLoginAttemptCounter(
      props.userDetails.id
    );
    if (res && res.message && res.message.status === "Success") {
      props.setShowModal(true);
      props.setModalType("success");
      props.setModalText(res.message.message);
      setLoginAttemptConfirmationModel(false);
      props.handleAddClose();
    } else {
      setShowModal(true);
      setModalType("error");
      setModalText(t("Something went wrong!"));
      setLoginAttemptConfirmationModel(false);
    }
    authCtx.toggleLoader(false);
  };

  const handleFailedAttemptSubmit = async () => {
    authCtx.toggleLoader(true);
    const res = await userService.resetFaildAttemptCounter(
      props.userDetails.id
    );
    if (res && res.message && res.message.status === "Success") {
      props.setShowModal(true);
      props.setModalType("success");
      props.setModalText(res.message.message);
      setFailedAttemptConfirmationModel(false);
      props.handleAddClose();
    } else {
      setShowModal(true);
      setModalType("error");
      setModalText(t("Something went wrong!"));
      setFailedAttemptConfirmationModel(false);
    }
    authCtx.toggleLoader(false);
  };

  return (
    <>
      <div className="row g-sm-3 mt-2">
        <div className="col-sm mb-3">
          <TextField
            required
            id="fName"
            label={t("Name")}
            className="w-100   "
            variant="outlined"
            size="small"
            value={userName}
            disabled
          />
        </div>
      </div>
      <div className="row g-sm-3">
        <div className="col-sm mb-3">
          <TextField
            required
            id="mobile"
            label={t("Mobile No.*")}
            className="w-100   "
            variant="outlined"
            size="small"
            value={mobileNo}
            disabled
          />
        </div>
      </div>
      {dateOfBirth && (
        <div className="row g-sm-3">
          <div className="col-sm mb-3">
            <TextField
              required
              id="mobile"
              label={t("DOB")}
              className="w-100   "
              variant="outlined"
              size="small"
              value={dateOfBirth}
              disabled
            />
          </div>
        </div>
      )}
      <div className="row g-sm-3">
        <div className="col-sm mb-3">
          <TextField
            required
            select
            id="role"
            label={t("Role")}
            className="w-100  "
            variant="outlined"
            size="small"
            error={roleError}
            value={roleId}
            onChange={(e: any) => {
              setRoleId(e.target.value);
              setRoleError(false);
            }}
          >
            {roleList &&
              roleList.map((item: any) => (
                <MenuItem value={item.id}>{item.text}</MenuItem>
              ))}
          </TextField>
        </div>
      </div>
      <div className="text-center border-top-0 pe-0 mb-2">
        <button
          className="btn btn-primary no-focus w-100"
          value=""
          //disabled={!isNumberVerified}
          onClick={() => {
            UpdateUserRole();
          }}
        >
          {t("Update Role")}
        </button>
      </div>
      <div className="text-center position-relative mt-1 mb-3" id="login_or">
        <strong>{t("or")}</strong>
      </div>
      <div className="row">
        <div className="col-md-6 col-sm-12 my-2 my-md-0">
          <button
            className="btn btn-primary w-100 no-focus"
            onClick={() => setLoginAttemptConfirmationModel(true)}
          >
            Reset Login Counter
          </button>
        </div>
        <div className="col-md-6 col-sm-12 my-2 my-md-0">
          <button
            className="btn btn-primary w-100 no-focus"
            onClick={() => setFailedAttemptConfirmationModel(true)}
          >
            Reset Failed Attempt Counter
          </button>
        </div>
      </div>

      <Dialog
        fullWidth
        maxWidth="sm"
        open={loginAttemptconfirmationModel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="text-primary">{t("Confirmation")}</DialogTitle>
        <DialogContent>
          {" "}
          <p className="fs-16 fw-600">
            {lang === "en"
              ? `Are you sure you want to reset login attempt counter for ${userName}?`
              : t("Are you sure you want to reset login attempt counter?")}
          </p>
        </DialogContent>
        <DialogActions>
          {" "}
          <button
            onClick={handleLoginComfirmationClose}
            className="btn btn-secondary no-focus"
          >
            {t("No")}
          </button>
          <button
            onClick={handleLoginAttemptSubmit}
            className="btn btn-primary"
          >
            {t("Yes")}
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        maxWidth="sm"
        open={failedAttemptconfirmationModel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="text-primary">{t("Confirmation")}</DialogTitle>
        <DialogContent>
          {" "}
          <p className="fs-16 fw-600">
            {lang === "en"
              ? `Are you sure you want to reset failed attempt counter for ${userName}?`
              : t("Are you sure you want to reset failed attempt counter?")}
          </p>
        </DialogContent>
        <DialogActions>
          {" "}
          <button
            onClick={handleFailedComfirmationClose}
            className="btn btn-secondary no-focus"
          >
            {t("No")}
          </button>
          <button
            onClick={handleFailedAttemptSubmit}
            className="btn btn-primary no-focus"
          >
            {t("Yes")}
          </button>
        </DialogActions>
      </Dialog>

      {modalType === "error" && (
        <Snackbar
          open={showModal}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="error">
            {modalText}
          </Alert>
        </Snackbar>
      )}
      {modalType === "success" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="success">
            {modalText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default SearchUser;
//test push
